<!-- Invoice and payments -->

<ion-row class="itinerary-row" id="InvoiceSection">
  <!-- Payments section -->
  <ng-container size="12" *ngIf="!doesInvoiceExists">
    <ion-col>
      <h6>Payments From Customers</h6>
      <ion-row size="12">
        <div class="w-100" *ngIf="allPaymentsOfLead">
          <app-grid-view [allData]="allPaymentsOfLead" [columns]="allPaymentsOfLeadColumns" [showColumnSelector]="false"
            [optionsValues]="false"></app-grid-view>
        </div>
      </ion-row>
      <ion-row>
        <ion-button class="unfilled-blue-btn" (click)="addPaymentToLead()">
          Add Payment
        </ion-button>
        <ion-button class="unfilled-blue-btn" (click)="refundPaymentToLead()">
          Refund Payment
        </ion-button>
        <ion-button class="unfilled-blue-btn" (click)="addInvoiceForClinet()">
          Add Invoice
        </ion-button>
      </ion-row>
    </ion-col>
  </ng-container>

  <!-- Invoice Section -->
  <ng-container *ngIf="doesInvoiceExists">
    <ion-col size="12">
      <h6>Invoice To Customers</h6>
      <ion-row size="12">
        <div class="w-100" *ngIf="clientInvoice">
          <app-grid-view [allData]="clientInvoice" [columns]="clientInvoiceColumns" [showColumnSelector]="false"
            [optionsValues]="invoiceOptionsValues" (triggerDeleteRow)="deleteInvoiceRow($event)"
            (triggerEditRow)="editInvoiceOpen($event)" (triggerViewRow)="viewInvoice($event)"
            (triggerAddPaymentRow)="addPaymentForInvoice($event)"></app-grid-view>
        </div>
      </ion-row>
      <ion-row>
        <ion-button class="unfilled-blue-btn" (click)="addInvoiceForClinet()">
          Add Invoice
        </ion-button>
      </ion-row>
    </ion-col>
  </ng-container>

  <!-- Vendor Invoice Section -->
  <ng-container>
    <ion-col size="12">
      <h6>Invoice From Vendors</h6>
      <ion-row size="12">
        <div class="w-100">
          <app-grid-view [allData]="allVendorInvoiceData" [columns]="allVendorInvoiceDataColumns"
            [showColumnSelector]="false"
            [optionsValues]="vendorInvoiceOptionsValues" (triggerDeleteRow)="deleteVendorInvoiceRow($event)"
            (triggerEditRow)="editVendorInvoiceOpen($event)" (triggerViewRow)="viewVendorInvoice($event)"
            (triggerAddPaymentRow)="addPaymentForVendorInvoice($event)"
            (emitRowOnCellClicked)="vendorRowCellClicked($event)"></app-grid-view>
        </div>
      </ion-row>
      <ion-row>
        <ion-button class="unfilled-blue-btn" (click)="openVendorInvoiceForm()">
          Attach Vendor Invoice
        </ion-button>
      </ion-row>
    </ion-col>
  </ng-container>
</ion-row>